import { List, Map, OrderedMap, Set } from 'immutable';
import { types as userTypes } from '@saucelabs/sl-module-user';

import * as types from './types';
import { types as activityTypes, constants as activityConstants, utils } from './../activity';
import { modify, toggleSetValue } from '../../utils';

const initialState = Map({
  group: null,
  loading: true,
  selectedTeams: Set(),
  teams: List(),
  activity: [],
  selectedUsers: Map(),
  users: Map({
    currentPage: 1,
    count: 0,
    results: OrderedMap(),
  }),
  userTableLoading: false,
});

const groupDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE:
      return state.set('loading', false);
    case types.GROUP_GET.SUCCESS:
    case types.GROUP_UPDATE.SUCCESS:
      return state.withMutations((mutable) => {
        mutable.set('group', payload);
        if (payload.teams) {
          mutable.set('teams', List(payload.teams));
        }
      });
    case types.UPDATE_USERLIST_OFFSET:
      return state.setIn(['users', 'currentPage'], payload);
    case types.GROUP_USERLIST_GET.REQUEST:
      return state.set('userTableLoading', true);
    case types.GROUP_USERLIST_GET.SUCCESS:
      return state.withMutations((mutable) => {
        const results = OrderedMap(payload.results.map((user) => [user.id, user]));
        mutable.setIn(['users', 'count'], payload.count);
        mutable.setIn(['users', 'results'], results);
        mutable.set('userTableLoading', false);
      });
    case types.GROUP_SET_CONCURRENCY.SUCCESS:
      return state.withMutations((mutable) => {
        const teams = state.get('teams');
        const newConcurrency = payload.virtual_machines_last_concurrency;

        mutable.update('group', (group) => ({
          ...group,
          virtual_machines_last_concurrency: newConcurrency,
        }));
        for (let i = 0; i < teams.size; i += 1) {
          mutable.updateIn(
            ['teams', i],
            (team) => ({
              ...team,
              settings: { ...team.settings, virtual_machines: newConcurrency },
            }),
          );
        }
        return mutable;
      });
    case types.TOGGLE_TEAM_SELECTION:
      return modify(state, 'selectedTeams', (selectedTeams) => toggleSetValue(selectedTeams, payload.id.toString()));
    case types.TOGGLE_ALL_TEAMS_SELECTION: {
      if (payload.checked) {
        return state.set('selectedTeams', Set(state.get('teams').map((team) => team.id)));
      }
      return state.set('selectedTeams', initialState.get('selectedTeams'));
    }
    case types.TOGGLE_USER_SELECTION: {
      if (state.get('selectedUsers').has(payload.id)) {
        return modify(state, 'selectedUsers', (selectedUsers) => selectedUsers.delete(payload.id));
      }
      return modify(state, 'selectedUsers', (selectedUsers) => selectedUsers.set(payload.id, payload));
    }
    case types.SET_USERS_SELECTION:
      if (payload.checked) {
        return modify(
          state,
          'selectedUsers',
          (selectedUsers) => selectedUsers.merge(payload.users),
        );
      }
      return modify(
        state,
        'selectedUsers',
        (selectedUsers) => selectedUsers.filter((user) => !payload.users.has(user.id)),
      );
    case userTypes.LAST_JOB_LIST_GET.SUCCESS:
      return modify(state, ['users', 'results'], (users) => users.map((user) => ({
        ...user,
        lastJob: user.username in payload ? payload[user.username] * 1000 : null,
      })));
    case userTypes.ACTIVITY_LIST_GET.SUCCESS:
      return modify(state, ['users', 'results'], (users) => users.map((user) => ({
        ...user,
        activity: payload[user.username] ?? null,
      })));
    case types.CLEANUP:
      return initialState;
    case types.TEAM_REMOVE_FROM_GROUP.SUCCESS: {
      return state.withMutations((mutable) => {
        const teamId = payload.teamId.toString();
        const teamsIndex = state.get('teams').findIndex((team) => (
          team.id === teamId
        ));

        return mutable
          .deleteIn(['teams', teamsIndex])
          .set('selectedTeams', mutable.get('selectedTeams').delete(teamId));
      });
    }
    case activityTypes.GET_GROUPS_ACTIVITY.SUCCESS: {
      const group = state.get('group');
      if (!group) return state;
      return state.withMutations((mutable) => {
        Object
          .entries(payload)
          .forEach(([groupId, value]) => {
            if (group.id !== groupId) {
              return;
            }

            const data = utils.serializeMultiActivityData(value,
              activityConstants.CHARTS_DATA_PERIOD,
              activityConstants.CHARTS_NUMBER_OF_PERIODS,
            );

            mutable.set('activity', data);
          });
      });
    }
    default:
      return state;
  }
};

export default groupDetailsReducer;
